// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => '关闭',
  error: () => '错误',
  warn: () => '警告',
  info: () => '信息',
  confirmation: () => '确认',
  progressIndeterminate: () => '进行中',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    '介于 ' + p['FROM_SECTION'] + ' 到 ' + p['TO_SECTION'] + ' 之间',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '。未找到匹配的区段。',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => '按 Enter 键以选择值。',
  indexer_touchInstructionText: () => '双击并按住以进入手势模式, 然后向上或向下拖动以调整值。',
  inputPassword_show: () => '显示密码',
  inputPassword_hide: () => '隐藏密码',
  inputPassword_hidden: () => '密码已隐藏',
  formControl_clear: () => '清除',
  formControl_loading: () => '正在加载',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    '超过了最大长度 ' + p['MAX_LENGTH'] + '。',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    '剩余 ' + p['CHARACTER_COUNT'] + ' 个字符。',
  formControl_requiredMessageDetail: () => '输入值。',
  select_requiredMessageDetail: () => '选择一个值。',
  select_noMatchesFound: () => '找不到匹配项。',
  select_oneMatchFound: () => '找到一个匹配',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => '找到 ' + p['TOTAL_SIZE'] + ' 个匹配项',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    '找到 ' + p['TOTAL_SIZE'] + ' 个或更多匹配项',
  selectMultiple_selectedValues: () => '所选值',
  selectMultiple_showSelectedValues: () => '仅显示选定值。',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    '已选择 ' + p['VALUE_COUNT'] + ' 个值。',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () => '按 Backspace 或 Delete 键删除所选值。',
  selectMultiple_apply: () => '应用',
  selectMultiple_back: () => '返回',
  selector_selected: () => '复选框已选中',
  selector_unselected: () => '复选框未选中',
  userAssistance_learnMore: () => '了解更多',
  userAssistance_required: () => '必需',
  filePicker_singleFileUploadError: () => '一次上载一个文件',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    '无法上载以下类型的文件: ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    '无法上载以下类型的文件: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => '未知',
  filePicker_dropzonePrimaryText: () => '拖放',
  filePicker_dropzoneSecondaryText: () => '选择一个文件或将文件放置在此处',
  filePicker_dropzoneSecondaryTextMultiple: () => '选择文件或将文件放置在此处。',
  filePicker_addFiles: () => '添加文件',
  plural_separator: () => ', ',
  inputNumber_increase: () => '增加',
  inputNumber_decrease: () => '减少',
  inputNumber_converterParseError: () => '请输入数字。',
  noData_message: () => '没有要显示的项',
  message_navigationFromMessagesRegion: () => '正在输入消息区域。按 F6 可返回到之前选中的元素。',
  message_navigationToMessagesRegion: () => '消息区域有新消息。使用 F6 可导航到最新的消息区域。',
  messageToast_allMessagesClosed: () => '所有快显 (toast) 消息都已关闭。',
  expandableList_groupCollapse: () => '折叠',
  expandableList_groupExpand: () => '展开',
  expandableList_expandCollapseInstructionText: () => '使用箭头键展开和折叠',
  list_suggestion: () => '建议',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    '第 ' + p['currentStep'] + ' 步，共 ' + p['numberOfSteps'] + ' 步',
  train_current: () => '当前',
  train_visited: () => '已访问',
  train_not_visited: () => '未访问',
  train_message_type: () => '消息类型',
  viz_drillable: () => '可钻取',
  dataVisualization_stateSelected: () => '选定',
  dataVisualization_stateUnselected: () => '未选定',
  dataVisualization_noData: () => '没有可显示的数据'
};
export default bundle;
